<template lang="pug">
.container
  el-dropdown(id="Layout-nickDropdown" trigger="click", @command="userAction")
    el-button(
      size="mini",
      type="text",
      id="Layout-nickButton"
    )
      font-awesome-icon(icon="user")
      span &nbsp; {{ this.$store.state.User.user.nick }}
    el-dropdown-menu(slot='dropdown')
      el-dropdown-item(id="Layout-logoutButton" command="logout")
        font-awesome-icon(icon="sign-out-alt")
        span &nbsp; {{ $t('Logout') }}
      el-dropdown-item(id="Layout-logoutButton" command="loggedInUsers")
        font-awesome-icon(icon="users")
        span &nbsp; {{ $t('Logged in users') }}
  el-dialog(
    :close-on-click-modal="false",
    :visible.sync="dialogVisible",
    @close="dialogVisible = false; component = null"
    fullscreen
  )
    component(v-if='component', v-bind:is='component')
</template>

<script>
import UsersLoggedIn from './UsersLoggedIn.vue'

export default {
  props: [],
  mixins: [],
  components: {
    UsersLoggedIn
  },
  created () {
  },
  watch: {
    foo: async function (newVal, oldVal) {
    }
  },
  data () {
    return {
      errors: [],
      dialogVisible: false,
      component: null
    }
  },
  methods: {
    async userAction (action) {
      switch (action) {
        case 'logout':
          await this.logout()
          break
        case 'userprefs':
          this.dialogVisible = true
          break
        case 'loggedInUsers':
          this.dialogVisible = true
          this.component = UsersLoggedIn
          break
        default:
          console.error('Unknown action', action)
          break
      }
    },
    async logout () {
      await this.$store.dispatch('User/logout', {}).catch(e => {})
      this.$router.push({ path: '/login' })
    }
  },
  computed: {
  }
}
</script>
<style lang="scss">
@import "../../../theme-m4b/src/common/var.scss";
.user-row, .table-header-row {
  display: flex;
  padding: 10px 0px;
  .cell {
    width: 50%;
    font-size: $--font-size-base;
  }
}
.user-row {
  border-bottom: $--border-light;
}
.table-header-row {
  .cell {
    color: $--color-text-secondary;
    .input {
      max-width: 150px;
      margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LayoutComponents/UserSubMenu.vue